import globalbg from "./globalbg.png"
import signature from "./signature.jpeg"
export const Images = {
    globalbg,
    signature
}